import React from 'react';
import { i18n } from 'core/i18n';
const { formatText, FormattedText } = i18n;

export default ({ onAccept }) => {
    return (
        <div
            className="videoScreen-container"
            style={{
                paddingLeft: '12px',
                paddingRight: '12px',
            }}
        >
            <br />
            <div className="row" style={{ height: '50px' }}>
                <div className="col-md-10 col-xs-10" style={{ paddingLeft: 0 }}>
                    <span className="font-heading3">{formatText('identity-videoCallNoMovementTitle')}</span>
                </div>
            </div>
            <div className="row">
                <FormattedText
                    value="identity-videoCallNoMovementText"
                    className="video-screen__modal-body-text font-paragraph2"
                />
            </div>
            <hr />
            <div className="row">
                <FormattedText
                    value="identity-videoCallAllowCameraMobileSafari"
                    className="video-screen__modal-body-text font-paragraph2"
                />
            </div>
            <div className="row">
                <FormattedText
                    value="identity-videoCallAllowCameraMobileChrome"
                    className="video-screen__modal-body-text font-paragraph2"
                />
            </div>
            <div className="row">
                <FormattedText
                    value="identity-videoCallAllowCameraMobile"
                    className="video-screen__modal-body-text font-paragraph2"
                />
            </div>
            <div className="video-screen__modal-buttons">
                <button className="form__button form__button-secondary error_button" onClick={onAccept}>
                    {formatText('button-understood')}
                </button>
            </div>
        </div>
    );
};
